import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import { router } from './routes';
import Promise from 'promise-polyfill';
import Mixins from './mixins';

import SCSS from './assets/scss/screen.scss';

Vue.use(Vuex);

Vue.mixin(Mixins);

const store = new Vuex.Store({
  debug: false,
  state: {
    hasApplicationLoaded: false,
    hasTutorialPlayed: false,
    isPhoneLandscape: true,
    sceneListing: [],
    selectedLang: 'en',
    activeSlide: 0,
    currentTutorial: 'tutorial-scenes.mp4',
    interface: {
      breadcrumbsOnly: false,
      isWhite: true,
      isVisible: true,
      isFooterVisible: true,
      isSearchVisible: false
    },
    listing: []
  }
});

new Vue({
  el: '#root',
  render: h => h(App),
  store,
  router,
});


router.afterEach(( to, from ) => {
  if(to.name == 'Virtual Tour') {
    document.getElementsByTagName('html')[0].classList.add('no-beta');
  }
  else {
    document.getElementsByTagName('html')[0].classList.remove('no-beta');
  }
  eventTracking.sendPageHit(to.path);
});

// Vue.config.devtools = true;


addToHomescreen({
  skipFirstVisit: false,
  maxDisplayCount: 0,
  startDelay: 1,
  lifespan: 30,
  icon: true,
  debug: false,
  appID: 'com.iguzzini.thelightexperience'
});



// WEBPACK FOOTER //
// ./src/main.js